'use client';
import { Icon, IconProp } from '@benzinga/core-ui';
import { TabType } from './index';
import { TabContext } from './TabContext';
import { useContext } from 'react';

interface TabNavItemProps {
  icon?: IconProp;
  tabs: TabType[];
  title: string;
  description?: string;
  onChange?: (tab: TabType) => void;
}

export const TabNavItem = ({ description, icon, onChange, tabs, title }: TabNavItemProps) => {
  const { activeTab, setActiveTab } = useContext(TabContext);
  const handleClick = () => {
    if (!tabs) {
      return;
    }
    // If there is a tab with the title that matches the title of the tab we clicked, set that tab as the active tab
    if (tabs.find(tab => tab.title === title)) {
      const newActiveTab = tabs.find(tab => tab.title === title) as TabType;
      setActiveTab(newActiveTab);
      onChange && onChange(newActiveTab);
    }
  };
  return (
    <li className={activeTab.title === title ? 'active' : ''} onClick={handleClick}>
      {icon && <Icon className="icon" icon={icon} />}
      <div>
        <span className={`title ${activeTab.title === title ? 'text-blue-500 active' : 'text-gray-500'}`}>{title}</span>
        <span className={`description ${activeTab.title === title ? 'text-blue-500 active' : 'text-gray-500'}`}>
          {description}
        </span>
      </div>
    </li>
  );
};

export default TabNavItem;
